(function() {
    document.addEventListener('alpine:init', () => {
        Alpine.data('climateCalculator', () => ({

            // === FACTORS FROM CUSTOMER TABLE ===

            transportValues: {
                Car: 0.1728026,        // kg CO2e per km
                ElectricCar: 0.051,    // kg CO2e per km
                Bus: 0.09465,          // kg CO2e per person-km
                ElectricBus: 0.007,    // kg CO2e per person-km
                Train: 0.00027,        // kg CO2e per km
                Boat: 0.01871,         // kg CO2e per person-km
                Flight: 119.9335712,   // kg CO2e per one-way trip
            },

            nightValues: {
                Nordic: 14.78,         // per guest-night
                Swedish: 17.6,
            },

            dayEventValue: 2.622,      // kg CO2e per day-only participant (no overnight)

            mealValues: {
                Breakfast: 0.72,
                LunchVegan: 0.3906,
                LunchVegetarian: 0.4296,
                LunchFishChickenPork: 0.7701,
                LunchBeefLamb: 5.1606,
                Coffee: 0.1342,
                Drink: 0.2333,
                Day1LunchFishChickenPork: 0.7701,
                Day1LunchBeefLamb: 5.1606,
                Day1LunchVegetarian: 0.4296,
                Day1LunchVegan: 0.3906,
                Day1LunchDrink: 0.2333,
                Day1Coffee: 0.1342,
                Day1DinnerFishChickenPork: 0.7701 + 3 * 0.2333,
                Day1DinnerBeefLamb: 5.1606 + 3 * 0.2333,
                Day1DinnerVegetarian: 0.4296 + 3 * 0.2333,
                Day1DinnerVegan: 0.3906 + 3 * 0.2333,
                Day2Breakfast: 0.72,
                Day2Coffee: 0.1342,
                Day2LunchFishChickenPork: 0.7701,
                Day2LunchBeefLamb: 5.1606,
                Day2LunchVegetarian: 0.4296,
                Day2LunchVegan: 0.3906,
                Day2LunchDrink: 0.2333,
            },

            // Optimal transport-faktor per transportslag (ersätter med bästa alternativ)
            optimalTransportFactors: {
                Car: 0.00027,  // → Tåg
                ElectricCar: 0.00027,  // → Tåg
                Bus: 0.007,    // → Elbuss
                ElectricBus: 0.007,    // redan optimalt
                Train: 0.00027,  // redan optimalt
                Boat: 0.00027,  // → Tåg
                Flight: 600 * 0.00027,  // → Tåg, ~600 km per enkelresa
            },

            // Optimal mat-faktor (alla lunch-varianter → vegansk)
            optimalMealFactors: {
                Breakfast: 0.72,    // inget bättre alternativ
                LunchVegan: 0.3906,  // redan optimalt
                LunchVegetarian: 0.3906,  // → Vegansk
                LunchFishChickenPork: 0.3906,  // → Vegansk
                LunchBeefLamb: 0.3906,  // → Vegansk
                Coffee: 0.1342,  // inget bättre alternativ
                Drink: 0.2333,  // inget bättre alternativ
                Day1LunchFishChickenPork: 0.3906,
                Day1LunchBeefLamb: 0.3906,
                Day1LunchVegetarian: 0.3906,
                Day1LunchVegan: 0.3906,
                Day1LunchDrink: 0.2333,
                Day1Coffee: 0.1342,
                Day1DinnerFishChickenPork: 0.3906 + 3 * 0.2333,
                Day1DinnerBeefLamb: 0.3906 + 3 * 0.2333,
                Day1DinnerVegetarian: 0.3906 + 3 * 0.2333,
                Day1DinnerVegan: 0.3906 + 3 * 0.2333,
                Day2Breakfast: 0.72,
                Day2Coffee: 0.1342,
                Day2LunchFishChickenPork: 0.3906,
                Day2LunchBeefLamb: 0.3906,
                Day2LunchVegetarian: 0.3906,
                Day2LunchVegan: 0.3906,
                Day2LunchDrink: 0.2333,
            },

            // === INPUT STATE ===
            transports: {
                Car: {km: null, people: null},
                ElectricCar: {km: null, people: null},
                Bus: {km: null, people: null},
                ElectricBus: {km: null, people: null},
                Train: {km: null, people: null},
                Boat: {km: null, people: null},
                Flight: {km: null, people: null},
            },

            nights: {
                Nordic: {gn: null, people: null},
                Swedish: {gn: null, people: null},
            },

            meals: {
                Breakfast: {people: 0},
                LunchVegan: {people: 0},
                LunchVegetarian: {people: 0},
                LunchFishChickenPork: {people: 0},
                LunchBeefLamb: {people: 0},
                Coffee: {people: 0},
                Drink: {people: 0},
                Day1LunchFishChickenPork: {people: 0},
                Day1LunchBeefLamb: {people: 0},
                Day1LunchVegetarian: {people: 0},
                Day1LunchVegan: {people: 0},
                Day1LunchDrink: {people: 0},
                Day1Coffee: {people: 0},
                Day1DinnerFishChickenPork: {people: 0},
                Day1DinnerBeefLamb: {people: 0},
                Day1DinnerVegetarian: {people: 0},
                Day1DinnerVegan: {people: 0},
                Day2Breakfast: {people: 0},
                Day2Coffee: {people: 0},
                Day2LunchFishChickenPork: {people: 0},
                Day2LunchBeefLamb: {people: 0},
                Day2LunchVegetarian: {people: 0},
                Day2LunchVegan: {people: 0},
                Day2LunchDrink: {people: 0},
            },

            result: null,
            displayedValue: null,
            _animRafId: null,
            _calcTimer: null,

            // UI state – tab navigation, view mode, Antal-tab fields, pill selectors
            activeTab: 'antal',
            viewMode: 'grupp',
            hoveredBar: null,
            participants: 0,
            overnight: 0,
            selectedTransports: [],
            selectedMeals: [],

            // === TIPS ROTATION ===
            tipIndex: 0,
            tipVisible: true,
            displayedTip: '',
            tipPaused: false,
            tipIntervalId: null,
            tips: [
                '<strong>Visste du?</strong><br> Du kan åka 11 varv runt jorden med tåg innan du nått upp till utsläppen från en enda flygresa.',
                '<strong>Tips!</strong><br> Genom att välja mer växtbaserad mat kan du minska matens utsläpp med upp till 90 procent.',
                '<strong>Visste du?</strong><br> En lunch med nötkött ger ca 13\u00d7 högre utsläpp än en vegansk lunch.',
                '<strong>Visste du?</strong><br> Elbuss ger ungefär 13\u00d7 lägre utsläpp per km än dieselbuss.',
                '<strong>Tips!</strong><br> En flygresa Stockholm–Göteborg ger ca 1 000× högre utsläpp än samma resa med tåg.',
            ],

            init() {
                this.displayedTip = this.tips[0];
                this._startTipInterval();
            },
            _startTipInterval() {
                if (this.tipIntervalId) {
                    clearInterval(this.tipIntervalId);
                }
                this.tipIntervalId = setInterval(() => {
                    if (this.tipPaused) {
                        return;
                    }
                    this.tipVisible = false;
                    setTimeout(() => {
                        this.tipIndex = (this.tipIndex + 1) % this.tips.length;
                        this.displayedTip = this.tips[this.tipIndex];
                        this.tipVisible = true;
                    }, 600);
                }, 6000);
            },
            printPdf() {
                const svgRaw = window._svmLogo || '';
                const logo = svgRaw
                    ? '<img src="data:image/svg+xml;base64,' +
                    btoa(unescape(encodeURIComponent(svgRaw))) +
                    '" width="120" height="35" alt="Svenska M\u00f6ten" style="display:block">'
                    : '';
                this.buildAndPrintPdf(logo);
            },

            buildAndPrintPdf(logo) {
                const today = new Date().toISOString().slice(0, 10);
                const result = parseFloat(this.result) || 0;
                const total = Math.round(result).toLocaleString('sv-SE');
                const perPerson = this.participants > 0
                    ? (result / this.participants).toFixed(1)
                    : '\u2013';

                const bar = (val, color) => {
                    const max = Math.max(
                        this.transportTotal,
                        this.nightsTotal,
                        this.mealsTotal,
                        this.optimalTransportTotal,
                        this.optimalNightsTotal,
                        this.optimalMealsTotal,
                        0,
                    );
                    const pct = max ? Math.max(
                        (val / max) * 100,
                        val > 0 ? 2 : 0,
                    ).toFixed(1) : 0;
                    return '<div style="height:10px;background:#f0ece4;border-radius:99px;overflow:hidden;margin-bottom:4px">'
                        +
                        '<div style="height:100%;width:' +
                        pct +
                        '%;background:' +
                        color +
                        ';border-radius:99px"></div></div>';
                };

                let transportRows = '';
                for (const key of this.selectedTransports) {
                    const km = this.transports[key].km || 0;
                    const ppl = this.transports[key].people || 0;
                    if (key === 'Flight') {
                        transportRows +=
                            '<p>' +
                            this._transportLabel(key) +
                            ': ' +
                            km +
                            ' enkelresor</p>';
                    } else {
                        transportRows +=
                            '<p>' +
                            this._transportLabel(key) +
                            ': ' +
                            ppl +
                            ' pers'
                            +
                            (km > 0 ? ', ' + km + ' km' : '') +
                            '</p>';
                    }
                }

                const day1MealKeys = [
                    'Day1LunchFishChickenPork', 'Day1LunchBeefLamb',
                    'Day1LunchVegetarian', 'Day1LunchVegan',
                    'Day1LunchDrink', 'Day1Coffee',
                    'Day1DinnerFishChickenPork', 'Day1DinnerBeefLamb',
                    'Day1DinnerVegetarian', 'Day1DinnerVegan',
                ];
                const day2MealKeys = [
                    'Day2Breakfast', 'Day2Coffee',
                    'Day2LunchFishChickenPork', 'Day2LunchBeefLamb',
                    'Day2LunchVegetarian', 'Day2LunchVegan',
                    'Day2LunchDrink',
                ];
                const buildMealRows = (keys) => keys
                    .filter(key => this.meals[key] && (this.meals[key].people || 0))
                    .map(key => '<p>' + this._mealLabel(key).replace(/^Dag [12] – /, '') + ': ' + this.meals[key].people + ' pers</p>')
                    .join('');
                let mealRows = '';
                if (this.overnight) {
                    const r1 = buildMealRows(day1MealKeys);
                    const r2 = buildMealRows(day2MealKeys);
                    if (r1) mealRows += '<h3>Dag 1</h3>' + r1;
                    if (r2) mealRows += '<h3>Dag 2</h3>' + r2;
                } else {
                    mealRows = buildMealRows(day1MealKeys);
                }

                const overnightSection = this.overnight > 0
                    ? '<h3>&#214;vernattning</h3>'
                    + '<p>' + this.overnight + ' &#246;vernattande</p>'
                    : '';

                const css = [
                    '*{box-sizing:border-box;margin:0;padding:0; }',
                    'body{font-family:Inter, sans-serif;color:#1a1a1a;padding:36px 40px;-webkit-print-color-adjust:exact;print-color-adjust:exact}',
                    '.hdr{display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid rgba(0,0,0,0.1);padding-bottom:16px;margin-bottom:24px}',
                    '.hdr-right{text-align:right}',
                    '.hdr-title{display:block;font-size:13px;font-weight:700;color:#3F2A1E;margin-bottom:2px}',
                    '.hdr-date{font-size:11px;color:#999}',
                    '.grid{display:grid;grid-template-columns:1fr 1fr;gap:48px}',
                    'h2{font-size:18px;font-weight:700;color:#3F2A1E;margin-bottom:14px;padding-bottom:8px;border-bottom:1px solid rgba(0,0,0,0.1);    font-family: DM Serif Display, serif;}',
                    'h3{font-size:12px;font-weight:700;color:#999;margin:14px 0 4px}',
                    'p{font-size:13px;margin:2px 0;line-height:1.5;color:#333}',
                    '.totals{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:22px}',
                    '.total-card{background:#f7f4ef;border-radius:8px;padding:14px 16px}',
                    '.total-num{font-family: DM Serif Display, serif;font-size:36px;font-weight:700;color:#3F2A1E;line-height:1;margin-bottom:4px}',
                    '.total-unit{font-size:11px;color:#946037;font-weight:700;margin-bottom:2px}',
                    '.total-label{font-size:11px;color:#888}',
                    '.bar-row{display:flex;align-items:center;gap:10px;margin-bottom:8px}',
                    '.bar-lbl{font-family:Inter, sans-serif; font-weight: 700;font-size:11px;color:#666;margin-bottom:2px;}',
                    '.bar-val{width:64px;font-size:11px;color:#666;text-align:left;flex-shrink:0;whitespace:nowrap;}',
                    '.legend{display:flex;gap:16px;font-size:11px;color:#888;margin-top:10px}',
                    '.dot{width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:4px;vertical-align:middle}',
                    '.info-grid{display:grid;grid-template-columns:1fr 1fr;gap:24px;margin-bottom:4px}',
                    '@media print{@page{margin:15mm}}',
                ].join('');

                const perPersonNum = this.participants > 0
                    ? (result / this.participants).toLocaleString(
                        'sv-SE',
                        {maximumFractionDigits: 1},
                    )
                    : '\u2013';

                const parts = [
                    '<!DOCTYPE html><html lang="sv"><head><meta charset="utf-8">',
                    '<title>Klimatpåverkan \u2013 konferensberäkning</title>',
                    '<style>',
                    css,
                    '</style></head><body>',
                    '<div class="hdr">',
                    logo,
                    '<div class="hdr-right">',
                    '<span class="hdr-title">Klimatpåverkan \u2013 konferensberäkning</span>',
                    '<span class="hdr-date">',
                    today,
                    '</span>',
                    '</div></div>',
                    '<div class="grid"><div>',
                    '<h2>Dina val</h2>',
                    '<div class="info-grid">',
                    '<div><h3>Antal</h3><p>',
                    this.participants,
                    ' deltagare</p>',
                    overnightSection,
                    '</div>',
                    transportRows ? '<div><h3>Transport</h3>' + transportRows + '</div>' : '<div></div>',
                    '</div>',
                    mealRows ? '<h3>Mat &amp; Dryck</h3>' + mealRows : '',
                    '</div><div>',
                    '<h2>Klimatpåverkan</h2>',
                    '<div class="totals">',
                    '<div class="total-card">',
                    '<div class="total-unit">Totalt</div>',
                    '<div class="total-num">',
                    total,
                    '</div>',
                    '<div class="total-label">kg CO\u2082e</div>',
                    '</div>',
                    '<div class="total-card">',
                    '<div class="total-unit">Per person</div>',
                    '<div class="total-num">',
                    perPersonNum,
                    '</div>',
                    '<div class="total-label">kg CO\u2082e</div>',
                    '</div>',
                    '</div>',
                    '<div>',
                    '<div class="bar-row"><div style="flex:1"><div class="bar-lbl">\u00d6vernattning</div>',
                    bar(this.nightsTotal, '#946037'),
                    bar(this.optimalNightsTotal, '#3F2A1E'),
                    '</div><div class="bar-val">',
                    this.nightsTotal.toFixed(1),
                    ' kg</div></div>',
                    '<div class="bar-row"><div style="flex:1"><div class="bar-lbl">Transport</div>',
                    bar(this.transportTotal, '#946037'),
                    bar(this.optimalTransportTotal, '#3F2A1E'),
                    '</div><div class="bar-val">',
                    this.transportTotal.toFixed(1),
                    ' kg</div></div>',
                    '<div class="bar-row"><div style="flex:1"><div class="bar-lbl">Mat &amp; Dryck</div>',
                    bar(this.mealsTotal, '#946037'),
                    bar(this.optimalMealsTotal, '#3F2A1E'),
                    '</div><div class="bar-val">',
                    this.mealsTotal.toFixed(1),
                    ' kg</div></div>',
                    '</div>',
                    '<div class="legend">',
                    '<span><span class="dot" style="background:#946037"></span>Dina val</span>',
                    '<span><span class="dot" style="background:#3F2A1E"></span>Mest hållbara alternativ</span>',
                    '</div></div></div></body></html>',
                ];

                const blob = new Blob(
                    [parts.join('')],
                    {type: 'text/html;charset=utf-8'},
                );
                const url = URL.createObjectURL(blob);
                const win = window.open(url, '_blank');
                win.addEventListener('load', () => {
                    win.print();
                    win.addEventListener('afterprint', () => {
                        win.close();
                        URL.revokeObjectURL(url);
                    });
                });
            },

            goToTip(index) {
                this.tipVisible = false;
                setTimeout(() => {
                    this.tipIndex = index;
                    this.displayedTip = this.tips[this.tipIndex];
                    this.tipVisible = true;
                    this._startTipInterval();
                }, 600);
            },

            // Subtotals per category – used by the chart to show relative bar heights
            transportTotal: 0,
            nightsTotal: 0,
            mealsTotal: 0,

            // Optimal subtotals – CO2e om man valt bästa alternativ per kategori
            optimalTransportTotal: 0,
            optimalNightsTotal: 0,
            optimalMealsTotal: 0,

            // Toggle transport pill selection
            toggleTransport(key) {
                const i = this.selectedTransports.indexOf(key);
                i === -1
                    ? this.selectedTransports.push(key)
                    : this.selectedTransports.splice(i, 1);
            },
            isTransportSelected(key) {
                return this.selectedTransports.includes(key);
            },

            // Toggle meal pill selection
            toggleMeal(key) {
                const i = this.selectedMeals.indexOf(key);
                i === -1
                    ? this.selectedMeals.push(key)
                    : this.selectedMeals.splice(i, 1);
            },
            isMealSelected(key) {
                return this.selectedMeals.includes(key);
            },
            _mealIncrease(key) {
                this.meals[key].people = (this.meals[key].people || 0) + 1;
            },
            _mealDecrease(key) {
                this.meals[key].people =
                    Math.max(0, (this.meals[key].people || 0) - 1);
            },

            // Sync Antal-tab UI fields into calculator nights state
            _syncNights() {
                this.nights['Swedish'].gn = 1;
                this.nights['Swedish'].people = this.overnight;
                this.nights['Nordic'].gn = 0;
                this.nights['Nordic'].people = 0;
            },

            // Returns bar height as CSS value relative to the tallest category
            _barHeight(val) {
                const max = Math.max(
                    this.transportTotal,
                    this.nightsTotal,
                    this.mealsTotal,
                );
                if (!max) {
                    return '6px';
                }
                return Math.max(val / max * 88, 4) + '%';
            },

            // Returns the result label string, handling per-person view and null state
            _resultLabel() {
                if (this.result === null) {
                    return '\u2013';
                }
                const val = parseFloat(this.result);
                if (this.viewMode === 'person' && this.participants > 0) {
                    return (val / this.participants).toLocaleString(
                            'sv-SE',
                            {maximumFractionDigits: 1},
                        ) +
                        '\u00a0kg\u00a0CO\u2082e\u00a0/\u00a0person';
                }
                return this.result + '\u00a0kg\u00a0CO\u2082e';
            },

            // Returns just the numeric part of the result for the large display
            _resultValue() {
                if (this.displayedValue === null) {
                    return '\u2013';
                }
                if (this.viewMode === 'person' && this.participants > 0) {
                    return this.displayedValue.toLocaleString(
                        'sv-SE',
                        {maximumFractionDigits: 1},
                    );
                }
                return Math.round(this.displayedValue).toLocaleString('sv-SE');
            },

            // Animates displayedValue from its current value to target (ease-out cubic, 500ms)
            _animateDisplayTo(target) {
                if (this._animRafId) {
                    cancelAnimationFrame(this._animRafId);
                }
                const start = this.displayedValue !== null
                    ? this.displayedValue
                    : 0;
                const duration = 500;
                const startTime = performance.now();
                const tick = (now) => {
                    const t = Math.min((now - startTime) / duration, 1);
                    const eased = 1 - Math.pow(1 - t, 6);
                    this.displayedValue = start + (target - start) * eased;
                    if (t < 1) {
                        this._animRafId = requestAnimationFrame(tick);
                    } else {
                        this.displayedValue = target;
                        this._animRafId = null;
                    }
                };
                this._animRafId = requestAnimationFrame(tick);
            },

            // Switches view mode and animates the displayed value to the new scale
            switchView(mode) {
                this.viewMode = mode;
                if (this.result === null) {
                    return;
                }
                const total = parseFloat(this.result);
                const target = (mode === 'person' && this.participants > 0)
                    ? total / this.participants
                    : total;
                this._animateDisplayTo(target);
            },

            // Returns width % for horizontal bar relative to the tallest category
            _hBarWidth(val) {
                const axisMax = this._axisMax();
                if (!axisMax || !val) {
                    return '0%';
                }
                const displayVal = (this.viewMode ===
                    'person' &&
                    this.participants >
                    0)
                    ? val / this.participants
                    : val;
                const pct = (displayVal / axisMax * 100).toFixed(1);
                return pct + '%';
            },

            // Formats a bar value for tooltip display, respecting viewMode and participants
            _barLabel(val) {
                if (!val) {
                    return '0 kg CO\u2082e';
                }
                const v = (this.viewMode === 'person' && this.participants > 0)
                    ? val / this.participants
                    : val;
                return v.toLocaleString('sv-SE', {maximumFractionDigits: 1}) +
                    ' kg CO\u2082e';
            },

            // Returns a nice rounded max value for the x-axis scale (based on largest single category)
            _axisMax() {
                const max = Math.max(
                    this.transportTotal,
                    this.nightsTotal,
                    this.mealsTotal,
                    this.optimalTransportTotal,
                    this.optimalNightsTotal,
                    this.optimalMealsTotal,
                    0,
                );
                if (!max) {
                    return 0;
                }
                const displayMax = (this.viewMode ===
                    'person' &&
                    this.participants >
                    0)
                    ? max / this.participants
                    : max;
                const mag = Math.pow(10, Math.floor(Math.log10(displayMax)));
                return Math.ceil(displayMax / mag) * mag;
            },

            // Returns a formatted axis label at the given fraction of _axisMax()
            _axisLabel(frac) {
                if (!this._axisMax()) {
                    return '';
                }
                const val = Math.round(this._axisMax() * frac);
                return val.toLocaleString('sv-SE');
            },

            // Returns human-readable label for a transport key
            _transportLabel(key) {
                return {
                    Car: 'Bil',
                    ElectricCar: 'Elbil',
                    Bus: 'Buss',
                    ElectricBus: 'Elbuss',
                    Flight: 'Flyg',
                    Train: 'T\u00e5g',
                    Boat: 'B\u00e5t',
                }[key] || key;
            },

            // Returns human-readable label for a meal key
            _mealLabel(key) {
                const labels = {
                    Breakfast: 'Frukost',
                    Coffee: 'Fika',
                    Drink: 'Dryck',
                    LunchVegan: 'Lunch/middag \u2013 Vegansk',
                    LunchVegetarian: 'Lunch/middag \u2013 Vegetarisk',
                    LunchFishChickenPork: 'Lunch/middag \u2013 Fisk/Kyckling/Fl\u00e4sk',
                    LunchBeefLamb: 'Lunch/middag \u2013 N\u00f6t/Lamm',
                    Day1LunchFishChickenPork: 'Dag 1 \u2013 Lunch Fisk/Kyckling/Fl\u00e4sk',
                    Day1LunchBeefLamb: 'Dag 1 \u2013 Lunch N\u00f6t/Lamm',
                    Day1LunchVegetarian: 'Dag 1 \u2013 Lunch Vegetarisk',
                    Day1LunchVegan: 'Dag 1 \u2013 Lunch Vegansk',
                    Day1LunchDrink: 'Dag 1 \u2013 Dryck (ej kranvatten)',
                    Day1Coffee: 'Dag 1 \u2013 Fika',
                    Day1DinnerFishChickenPork: 'Dag 1 \u2013 Middag Fisk/Kyckling/Fl\u00e4sk inkl. dryck',
                    Day1DinnerBeefLamb: 'Dag 1 \u2013 Middag N\u00f6t/Lamm inkl. dryck',
                    Day1DinnerVegetarian: 'Dag 1 \u2013 Middag Vegetarisk inkl. dryck',
                    Day1DinnerVegan: 'Dag 1 \u2013 Middag Vegansk inkl. dryck',
                    Day2Breakfast: 'Dag 2 \u2013 Frukost',
                    Day2Coffee: 'Dag 2 \u2013 Fika',
                    Day2LunchFishChickenPork: 'Dag 2 \u2013 Lunch Fisk/Kyckling/Fl\u00e4sk',
                    Day2LunchBeefLamb: 'Dag 2 \u2013 Lunch N\u00f6t/Lamm',
                    Day2LunchVegetarian: 'Dag 2 \u2013 Lunch Vegetarisk',
                    Day2LunchVegan: 'Dag 2 \u2013 Lunch Vegansk',
                    Day2LunchDrink: 'Dag 2 \u2013 Dryck (ej kranvatten)',
                };
                return labels[key] || key;
            },

            _scheduledCalc() {
                // Touch all reactive deps synchronously so Alpine tracks them,
                // then defer the heavy work to avoid intermediate-state flicker.
                void this.participants; void this.overnight; void this.viewMode;
                void this.selectedTransports.length; void this.selectedMeals.length;
                for (const t of Object.values(this.transports)) { void t.km; void t.people; }
                for (const n of Object.values(this.nights)) { void n.gn; void n.people; }
                for (const m of Object.values(this.meals)) { void m.people; }
                clearTimeout(this._calcTimer);
                this._calcTimer = setTimeout(() => this.calculate(), 150);
            },

            calculate() {
                this._syncNights();
                let total = 0;

                // === TRANSPORT ===
                for (const [key, data] of Object.entries(this.transports)) {
                    if (!this.selectedTransports.includes(key)) {
                        continue;
                    }
                    const km = Number(data.km) || 0;
                    const people = Number(data.people) || 0;
                    const factor = this.transportValues[key];

                    if (key === 'Flight') {
                        total += km * factor; // antal enkelresor × faktor
                    } else {
                        total += km * people * factor; // antal × sträcka × faktor
                    }
                }

                // === HOTEL NIGHTS ===
                for (const [key, data] of Object.entries(this.nights)) {
                    const gn = Number(data.gn) || 0;
                    const people = Number(data.people) || 0;
                    total += gn * people * this.nightValues[key];
                }

                // === DAY-EVENT PARTICIPANTS (no overnight) ===
                const dayParticipants = Math.max(
                    0,
                    (Number(this.participants) || 0) -
                    (Number(this.overnight) || 0),
                );
                total += dayParticipants * this.dayEventValue;

                // === MEALS & DRINKS ===
                const twoDayKeys = [
                    'Day1LunchFishChickenPork',
                    'Day1LunchBeefLamb',
                    'Day1LunchVegetarian',
                    'Day1LunchVegan',
                    'Day1LunchDrink',
                    'Day1Coffee',
                    'Day1DinnerFishChickenPork',
                    'Day1DinnerBeefLamb',
                    'Day1DinnerVegetarian',
                    'Day1DinnerVegan',
                    'Day2Breakfast',
                    'Day2Coffee',
                    'Day2LunchFishChickenPork',
                    'Day2LunchBeefLamb',
                    'Day2LunchVegetarian',
                    'Day2LunchVegan',
                    'Day2LunchDrink',
                ];
                for (const [key, data] of Object.entries(this.meals)) {
                    if (!twoDayKeys.includes(key) &&
                        !this.selectedMeals.includes(key)) {
                        continue;
                    }
                    const people = Number(data.people) || 0;
                    total += people * this.mealValues[key];
                }

                this.result = total.toFixed(2);
                const displayTarget = (this.viewMode ===
                    'person' &&
                    this.participants >
                    0)
                    ? total / this.participants
                    : total;
                this._animateDisplayTo(displayTarget);

                // Compute per-category subtotals for chart bars
                let tTransport = 0;
                for (const [key, data] of Object.entries(this.transports)) {
                    if (!this.selectedTransports.includes(key)) {
                        continue;
                    }
                    const km = Number(data.km) || 0;
                    const people = Number(data.people) || 0;
                    const factor = this.transportValues[key];
                    if (key === 'Flight') {
                        tTransport += km * factor;
                    } else {
                        tTransport += km * people * factor;
                    }
                }
                let tNights = 0;
                for (const [key, data] of Object.entries(this.nights)) {
                    tNights +=
                        (Number(data.gn) || 0) *
                        (Number(data.people) || 0) *
                        this.nightValues[key];
                }
                tNights += dayParticipants * this.dayEventValue;
                let tMeals = 0;
                for (const [key, data] of Object.entries(this.meals)) {
                    if (!twoDayKeys.includes(key) &&
                        !this.selectedMeals.includes(key)) {
                        continue;
                    }
                    tMeals += (Number(data.people) || 0) * this.mealValues[key];
                }
                this.transportTotal = tTransport;
                this.nightsTotal = tNights;
                this.mealsTotal = tMeals;

                // Beräkna optimala subtotals
                let oTransport = 0;
                for (const [key, data] of Object.entries(this.transports)) {
                    if (!this.selectedTransports.includes(key)) {
                        continue;
                    }
                    const km = Number(data.km) || 0;
                    const people = Number(data.people) || 0;
                    const factor = this.optimalTransportFactors[key];
                    if (key === 'Flight') {
                        oTransport += km * factor;
                    } else {
                        oTransport += km * people * factor;
                    }
                }
                let oNights = 0;
                for (const [key, data] of Object.entries(this.nights)) {
                    oNights +=
                        (Number(data.gn) || 0) *
                        (Number(data.people) || 0) *
                        this.nightValues['Swedish'];
                }
                oNights += dayParticipants * this.dayEventValue;
                let oMeals = 0;
                for (const [key, data] of Object.entries(this.meals)) {
                    if (!twoDayKeys.includes(key) &&
                        !this.selectedMeals.includes(key)) {
                        continue;
                    }
                    oMeals +=
                        (Number(data.people) || 0) *
                        this.optimalMealFactors[key];
                }
                this.optimalTransportTotal = oTransport;
                this.optimalNightsTotal = oNights;
                this.optimalMealsTotal = oMeals;
            },

        }));
    });
}());
